// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KidStoriesFullPage_kidStoriesContainer__pCDJh {
    padding: 2rem;
    background-color: #1a1a1a;
    color: white;
  }
  
  .KidStoriesFullPage_sectionHeader__3nJjH {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
  }
  
  .KidStoriesFullPage_title__vp3t5 {
    font-size: 1.5rem;
    font-weight: 500;
  }
  
  .KidStoriesFullPage_viewAll__orFxI {
    color: white;
    text-decoration: none;
    font-size: 0.9rem;
    opacity: 0.8;
  }
  
  .KidStoriesFullPage_cardGrid__P2lzm {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1.5rem;
  }
  
  .KidStoriesFullPage_cardContainer__CHyL8 {
    background-color: #242424;
    border-radius: 8px;
    overflow: hidden;
    transition: transform 0.2s;
  }
  
  .KidStoriesFullPage_cardContainer__CHyL8:hover {
    transform: translateY(-5px);
  }
  
  .KidStoriesFullPage_thumbnailContainer__nj\\+be {
    position: relative;
    width: 100%;
    padding-top: 56.25%; /* 16:9 Aspect Ratio */
  }
  
  .KidStoriesFullPage_thumbnail__EXRU4 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 15px;
  }
  
  .KidStoriesFullPage_cardContent__fDfar {
    padding: 1rem;
  }
  .KidStoriesFullPage_pageTitle__5-BZw{
    font-size: 1.5rem !important;
  }
  .KidStoriesFullPage_title__vp3t5 {
    font-size: 1rem;
    margin: 0 0 0.5rem 0;
    font-weight: 500;
  }
  
  .KidStoriesFullPage_metaInfo__aJb3J {
    display: flex;
    align-items: center;
    font-size: 0.8rem;
    color: #999;
    margin-bottom: 0.5rem;
  }
  .KidStoriesFullPage_fullPageTitle__RElLF{
    font-size: 2rem !important;
    padding-top: 4rem;
  }
  .KidStoriesFullPage_dot__IKE2k {
    margin: 0 0.5rem;
  }
  .KidStoriesFullPage_description__WyZrO {
    font-size: 0.9rem;
    color: #999;
    margin-bottom: 1rem;
    line-height: 1.4;
  }
  .KidStoriesFullPage_youtubeIcon__9useg {
    vertical-align: middle;
    margin-right: 4px;
    width: 20px !important;
    height: 20px !important;
    color: #ff0000;
  }
  .KidStoriesFullPage_watchButton__VBZhX {
    background-color: #ff0000;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.9rem;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .KidStoriesFullPage_watchButton__VBZhX:hover {
    background-color: #cc0000;
  }
  
  .KidStoriesFullPage_icon__\\+7j1q {
    width: 16px;
    height: 16px;
    color: #000;
    border-radius: 50%;
    background-color: #fff;
    padding: 5px;
  }
 
  @media (max-width: 1024px) {
    .KidStoriesFullPage_cardGrid__P2lzm {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  
  @media (max-width: 768px) {
    .KidStoriesFullPage_cardGrid__P2lzm {
      grid-template-columns: repeat(2, 1fr);
    }
    .KidStoriesFullPage_kidStoriesContainer__pCDJh{
      padding-top: 2rem !important;
    }
  }
  
  @media (max-width: 480px) {
    .KidStoriesFullPage_cardGrid__P2lzm {
      grid-template-columns: 1fr;
    }
    .KidStoriesFullPage_kidStoriesContainer__pCDJh{
      padding-top: 2rem !important;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/video-pages/css/KidStoriesFullPage.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB,EAAE,sBAAsB;EAC7C;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,eAAe;IACf,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,qBAAqB;EACvB;EACA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE;MACE,qCAAqC;IACvC;EACF;;EAEA;IACE;MACE,qCAAqC;IACvC;IACA;MACE,4BAA4B;IAC9B;EACF;;EAEA;IACE;MACE,0BAA0B;IAC5B;IACA;MACE,4BAA4B;IAC9B;EACF","sourcesContent":[".kidStoriesContainer {\n    padding: 2rem;\n    background-color: #1a1a1a;\n    color: white;\n  }\n  \n  .sectionHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.5rem;\n  }\n  \n  .title {\n    font-size: 1.5rem;\n    font-weight: 500;\n  }\n  \n  .viewAll {\n    color: white;\n    text-decoration: none;\n    font-size: 0.9rem;\n    opacity: 0.8;\n  }\n  \n  .cardGrid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 1.5rem;\n  }\n  \n  .cardContainer {\n    background-color: #242424;\n    border-radius: 8px;\n    overflow: hidden;\n    transition: transform 0.2s;\n  }\n  \n  .cardContainer:hover {\n    transform: translateY(-5px);\n  }\n  \n  .thumbnailContainer {\n    position: relative;\n    width: 100%;\n    padding-top: 56.25%; /* 16:9 Aspect Ratio */\n  }\n  \n  .thumbnail {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 15px;\n  }\n  \n  .cardContent {\n    padding: 1rem;\n  }\n  .pageTitle{\n    font-size: 1.5rem !important;\n  }\n  .title {\n    font-size: 1rem;\n    margin: 0 0 0.5rem 0;\n    font-weight: 500;\n  }\n  \n  .metaInfo {\n    display: flex;\n    align-items: center;\n    font-size: 0.8rem;\n    color: #999;\n    margin-bottom: 0.5rem;\n  }\n  .fullPageTitle{\n    font-size: 2rem !important;\n    padding-top: 4rem;\n  }\n  .dot {\n    margin: 0 0.5rem;\n  }\n  .description {\n    font-size: 0.9rem;\n    color: #999;\n    margin-bottom: 1rem;\n    line-height: 1.4;\n  }\n  .youtubeIcon {\n    vertical-align: middle;\n    margin-right: 4px;\n    width: 20px !important;\n    height: 20px !important;\n    color: #ff0000;\n  }\n  .watchButton {\n    background-color: #ff0000;\n    color: white;\n    border: none;\n    padding: 0.5rem 1rem;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 0.9rem;\n    transition: background-color 0.2s;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n  \n  .watchButton:hover {\n    background-color: #cc0000;\n  }\n  \n  .icon {\n    width: 16px;\n    height: 16px;\n    color: #000;\n    border-radius: 50%;\n    background-color: #fff;\n    padding: 5px;\n  }\n \n  @media (max-width: 1024px) {\n    .cardGrid {\n      grid-template-columns: repeat(3, 1fr);\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .cardGrid {\n      grid-template-columns: repeat(2, 1fr);\n    }\n    .kidStoriesContainer{\n      padding-top: 2rem !important;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .cardGrid {\n      grid-template-columns: 1fr;\n    }\n    .kidStoriesContainer{\n      padding-top: 2rem !important;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"kidStoriesContainer": `KidStoriesFullPage_kidStoriesContainer__pCDJh`,
	"sectionHeader": `KidStoriesFullPage_sectionHeader__3nJjH`,
	"title": `KidStoriesFullPage_title__vp3t5`,
	"viewAll": `KidStoriesFullPage_viewAll__orFxI`,
	"cardGrid": `KidStoriesFullPage_cardGrid__P2lzm`,
	"cardContainer": `KidStoriesFullPage_cardContainer__CHyL8`,
	"thumbnailContainer": `KidStoriesFullPage_thumbnailContainer__nj+be`,
	"thumbnail": `KidStoriesFullPage_thumbnail__EXRU4`,
	"cardContent": `KidStoriesFullPage_cardContent__fDfar`,
	"pageTitle": `KidStoriesFullPage_pageTitle__5-BZw`,
	"metaInfo": `KidStoriesFullPage_metaInfo__aJb3J`,
	"fullPageTitle": `KidStoriesFullPage_fullPageTitle__RElLF`,
	"dot": `KidStoriesFullPage_dot__IKE2k`,
	"description": `KidStoriesFullPage_description__WyZrO`,
	"youtubeIcon": `KidStoriesFullPage_youtubeIcon__9useg`,
	"watchButton": `KidStoriesFullPage_watchButton__VBZhX`,
	"icon": `KidStoriesFullPage_icon__+7j1q`
};
export default ___CSS_LOADER_EXPORT___;
